
import './App.css';
import { useState } from 'react';
import Header from './components/Header';
import Footer from './components/Footer';


function App() {
  const x = 0;
  const [count, setCount] = useState(x);

function decrease() {
  setCount(count-1)
}

function increase() {
  setCount(count+1)
}

  return (
    <div className="App">
      <Header/>
      <button onClick={decrease} className="redButton" >-</button>
      <span className="mySpan" >{count}</span>
      <button onClick={increase} className="greenButton"  >+</button>
    <Footer/>
    </div>
    
  );
}

export default App;
